export var IdGrowthFundOfferId;
(function (IdGrowthFundOfferId) {
    IdGrowthFundOfferId[IdGrowthFundOfferId["Gold"] = 50] = "Gold";
})(IdGrowthFundOfferId || (IdGrowthFundOfferId = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdGrowthFundOfferId.ts
// module id = 2288
// module chunks = 3